{ "compressionlevel":-1,
 "editorsettings":
    {
     "export":
        {
         "format":"json",
         "target":"tutorial.json"
        }
    },
 "height":14,
 "infinite":false,
 "layers":[
        {
         "data":[63, 2, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 9, 64, 2, 2, 2, 4, 64, 64, 64, 4, 4, 64, 4, 4, 3, 2, 64, 4, 2, 2, 2, 3, 8, 2, 2, 2, 17, 3, 2, 2, 64, 64, 64, 64, 64, 64, 2, 64, 64, 2, 64, 64, 64, 1, 64, 64, 4, 64, 64, 64, 2, 64, 64, 2, 3, 2, 2, 2, 12, 2, 3, 4, 64, 64, 5, 64, 64, 64, 64, 64, 64, 64, 64, 64, 2, 4, 64, 64, 2, 64, 64, 64, 64, 64, 64, 64, 64, 64, 2, 4, 64, 64, 2, 4, 4, 4, 64, 64, 64, 64, 64, 64, 3, 64, 64, 64, 17, 2, 3, 2, 2, 3, 2, 10, 64, 64, 2, 64, 64, 64, 1, 64, 64, 64, 64, 2, 64, 64, 64, 64, 2, 4, 64, 64, 2, 64, 3, 2, 2, 2, 4, 64, 64, 4, 17, 2, 2, 3, 2, 2, 2, 64, 64, 2, 4, 64, 64, 64, 64, 64, 64, 4, 2, 64, 3, 64, 64, 2, 64, 64, 64, 64, 64, 64, 64, 64, 11, 64, 2, 2, 2, 15, 4, 64],
         "height":14,
         "id":1,
         "name":"tiles",
         "opacity":1,
         "type":"tilelayer",
         "visible":true,
         "width":14,
         "x":0,
         "y":0
        }],
 "nextlayerid":2,
 "nextobjectid":1,
 "orientation":"orthogonal",
 "renderorder":"right-down",
 "tiledversion":"1.6.0",
 "tileheight":32,
 "tilesets":[
        {
         "firstgid":1,
         "source":"tileset.tsx"
        }],
 "tilewidth":32,
 "type":"map",
 "version":"1.6",
 "width":14
}